export default __webpack_public_path__ + "static/media/Css.cdd961c1.png";